import ReactModal from 'react-modal';
import theme from '../styles/theme';

type Props = {
  isOpen: boolean;
  setOpen: any;
  onDismiss?: () => void;
  onClose?: (courseId: any, section: any) => void;
  children?: any;
  customStyle?: any;
  overlayClassName?: any;
};

function CompetencyModal({
  isOpen,
  setOpen,
  onDismiss,
  onClose,
  children = null,
  customStyle,
}: Props): JSX.Element {
  return (
    <>
      <ReactModal
        ariaHideApp={false}
        isOpen={isOpen}
        onRequestClose={() => {
          setOpen(false);
          onClose?.('', '');
        }}
        closeTimeoutMS={500}
        style={{
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 9900,
            overflow: 'auto',
            ...customStyle?.overlay,
          },
          content: {
            fontFamily: 'Montserrat',
            color: '#FFFFFF',
            background: 'rgba(11, 12, 33, 0.88)',
            backdropFilter: 'blur(44px)',
            maxWidth: 585,
            inset: '74px 0px 0px calc(100% - 585px)',
            position: 'absolute',
            padding: theme.spacing.x3,
            borderRadius: 'none',
            border: 'unset',
            overflow: 'hidden',
            boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.2)',
            ...customStyle?.content,
          },
        }}>
        {children}
      </ReactModal>
    </>
  );
}

export default CompetencyModal;
